module.exports = __webpack_public_path__ + "img/top-1.ffc460f0.png";